import { StyleSheet } from '@react-pdf/renderer';

// Create pdf styles
export const styles = StyleSheet.create({
  spacing: {
    marginTop: 6,
    marginBottom: 6,
  },
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    textAlign: 'left',
    fontFamily: 'Helvetica-Bold',
  },
  author: {
    fontSize: 14,
    textAlign: 'left',
    marginBottom: 0,
    fontFamily: 'Helvetica',
  },
  authorBold: {
    fontSize: 14,
    textAlign: 'left',
    marginBottom: 5,
    fontFamily: 'Helvetica-Bold',
  },
  subtitle: {
    fontSize: 18,
    margin: 12,
    marginBottom: 0,
    fontFamily: 'Helvetica-Bold',
  },
  text: {
    margin: 12,
    fontSize: 14,
    textAlign: 'left',
    fontFamily: 'Helvetica',
  },
  textBold: {
    margin: 12,
    fontSize: 14,
    textAlign: 'left',
    fontFamily: 'Helvetica-Bold',
  },
  image: {
    marginVertical: 15,
    marginHorizontal: 100,
  },
  header: {
    fontSize: 12,
    marginBottom: 20,
    textAlign: 'left',
    color: 'grey',
  },
  pageNumber: {
    position: 'absolute',
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    color: 'grey',
  },
});
